import React, { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Showcase from './components/Showcase';
import About from './components/About';
import Process from './components/Process';
import Contact from './components/Contact';
import Cursor from './components/Cursor';
import ThemeToggle from './components/ThemeToggle';
import LoadingScreen from './components/LoadingScreen';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isDark, setIsDark] = useState(true);

  useEffect(() => {
    // Check for saved theme preference or default to dark
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      setIsDark(savedTheme === 'dark');
    }

    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Apply theme to document
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
  }, [isDark]);

  const toggleTheme = () => {
    setIsDark(!isDark);
  };

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className={`min-h-screen ${isDark ? 'dark' : ''} bg-white text-gray-900 dark:bg-black dark:text-white transition-all duration-500`}>
      <Cursor />
      <ThemeToggle isDark={isDark} toggleTheme={toggleTheme} />
      
      <main className="relative">
        {/* Hero Section */}
        <section id="hero" className="section-snap min-h-screen">
          <Hero />
        </section>

        {/* Showcase Section */}
        <section id="showcase" className="section-snap min-h-screen">
          <Showcase />
        </section>

        {/* About Section */}
        <section id="about" className="section-snap min-h-screen">
          <About />
        </section>

        {/* Process Section */}
        <section id="process" className="section-snap min-h-screen">
          <Process />
        </section>

        {/* Contact Section */}
        <section id="contact" className="section-snap min-h-screen">
          <Contact />
        </section>
      </main>
    </div>
  );
}

export default App;
